module.exports = __webpack_public_path__ + "img/service_1.d04ffd3b.png";